import { Controller, useFormContext } from "react-hook-form";
import { SwitchUserFormValues } from "../../types";
import { View } from "react-native-ui-lib";
import { MfaMethodOptions } from "../MfaMethodOptions";

export interface SelectMfaMethodFieldsetProps {}

export const SelectMfaMethodFieldset = ({}: SelectMfaMethodFieldsetProps) => {
  const { control, watch } = useFormContext<SwitchUserFormValues>();
  const strategies = watch("mfaStrategies");
  return (
    <View>
      <Controller
        control={control}
        name="mfaStrategy"
        render={({ field: { onChange, value } }) => {
          return (
            <MfaMethodOptions
              onChange={onChange}
              value={value}
              strategies={(strategies || []) as any}
            />
          );
        }}
      />
    </View>
  );
};
